import SiteMapViewer from "@/components/site_map/SiteMapViewer.svelte"
import { Controller } from "@hotwired/stimulus"
import { getSiteMap, getSiteMapUnitStatuses } from "@/api/site_maps"

export default class extends Controller {
  static values = {
    siteMapId: String,
  }

  connect() {
    this.siteMapViewer = new SiteMapViewer({
      props: {
        getSiteMap,
        getUnitStatuses: getSiteMapUnitStatuses,
        isRestricted: false,
        siteMapId: this.siteMapIdValue,
      },
      target: this.element,
    })
  }

  disconnect() {
    this.siteMapViewer.$destroy()
  }
}
